export default function textFieldRegister({ name, register }) {
  const { ref: inputRef, ...props } = register(name);
  return { inputRef, ...props };
}
